<template>
  <div class="sdk-universal-config-manage-page">
    <basic-container>
      <div class="search-form-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-select v-model="formInline.categoryCode" clearable placeholder="配置分类">
              <el-option v-for="item in sdkCategoryOptions" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input clearable v-model="formInline.search" placeholder="配置名称/KEY"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH'" >搜索</el-button>
            <el-button type="primary" @click="openDialog" plain v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD'" >新增</el-button>
            <el-button type="danger" @click="handleDelete" plain v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'" >删除</el-button>
          </el-form-item>
        </el-form>
      </div>

      <avue-crud ref="crud" :option="option" :page.sync="page" :table-loading="loading" @on-load="getList"
        @selection-change="handleSelectionChange" :data="data">
        <template slot-scope="scope" slot="menu">
          <el-button size="small" @click="handleEdit(scope.row)" type="text" icon="el-icon-edit" v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT'" >编辑</el-button>
          <el-button size="small" type="text" @click="handleDeleteRow(scope.row)" icon="el-icon-delete" v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'" >删除</el-button>
          <!-- <el-button size="small" type="text"   >飞书提醒</el-button>
          <el-button size="small" type="text" @click="getLog(scope.row)">日志</el-button> -->
        </template>
      </avue-crud>

    </basic-container>

    <el-dialog :title="isEdit?'编辑':'新增'" append-to-body :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" width="30%" @close="onDialogClose">
      <div class="dialog-content-wrap">
        <el-form :model="formModel" :rules="rules" ref="editForm" size="small" label-width="100px">
          <el-form-item label="配置分类" prop="categoryCode">
            <el-select v-model="formModel.categoryCode" placeholder="请选择配置分类">
              <el-option v-for="item in sdkCategoryOptions" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="配置名称" prop="name">
            <el-input v-model="formModel.name"></el-input>
          </el-form-item>
          <el-form-item label="KEY值" prop="code">
            <el-input :disabled=isEdit v-model="formModel.code"></el-input>
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <el-select :disabled=isEdit v-model="formModel.dataType" placeholder="请选择数据类型">
              <el-option v-for="item in dataTypeOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配置说明" prop="dataDescr">
            <el-input type="textarea" :rows="4" v-model="formModel.dataDescr"></el-input>
          </el-form-item>
           <el-form-item label="value示例" prop="valueEx">
            <el-input type="textarea" maxlength="999999"  show-word-limit  :rows="4" v-model="formModel.valueEx"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <LogDialog ref="logDialog"></LogDialog>
  </div>
</template>
<script>
import options from './option';
import { getToken } from '@/util/auth'
import {
  getDictionary
} from "@/api/system/dict";
import {
  getManageList,
  delManage,
  saveManageInfo,
  editManageInfo
} from '@/api/sdk-universal-config';
import { merge } from '@/util/common';
import LogDialog from './log.vue';
export default {
  name: 'SdkUniversalConfigPage',
  components: {
    LogDialog
  },
  data() {
    return {
      sdkCategoryOptions: [],
      selectIds: '',
      isEdit: false,
      currentRow: null,
      formInline: {
        categoryCode: '',
        paramQuery: ''
      },
      typeOptions: [],
      dataTypeOptions: [
        {
          id: 1,
          name: '字符串'
        },
        {
          id: 2,
          name: '数字'
        },
        {
          id: 3,
          name: 'JSON'
        }
      ],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      visible: false,
      formModel: {
        categoryCode: '',
        categoryName: '',
        dataType: '', // 数据类型:1 字符串,2 数字,3 json
        dataDescr: '',
        code: '',
        valueEx:''
      },
      rules: {
        categoryCode: [
          { required: true, message: '请输入配置分类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入配置名称', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入KEY值', trigger: 'blur' }],
        dataType: [
          { required: true, message: '请选择数据类型', trigger: 'blur' }
        ],
        dataDescr: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        valueEx: [{ required: true, message: '请输入value示例', trigger: 'blur' }],
      },
      params: {},
      loading: false,
      data: [],
      option: {}
    };
  },
  created() {
    this.option = options(this);


    this.headers = { 'Lebo-Auth': 'bearer ' + getToken() }
    getDictionary({ code: 'SDKConfigure_Category' }).then(res => {
      console.log("开始查询数据---", res)
      this.sdkCategoryOptions = res.data.data.map(r => { return { "dictKey": r.dictKey, "dictValue": r.dictValue } })
      //this.eventbodtForm.action = [...this.eventbodtForm.action , ...listMap]
    })
  },
  methods: {
    /** 操作日志 */
    getLog(){
      this.$refs.logDialog.show()
    },
    handleSearch() {
      this.page.currentPage = 1;
      this.getList();
    },
    // 获取数据
    handleSelectionChange(selection) {
      this.selectIds = selection.map(item => item.id).join(',');
    },
    // 格式数据类型
    formatDataType({ dataType }) {
      for (let item of this.dataTypeOptions) {
        if (item.id === dataType) {
          return item.name;
        }
      }
    },
    getList() {
      const query = merge({}, this.formInline, {
        current: this.page.currentPage,
        size: this.page.pageSize
      });
      getManageList(query).then(res => {
        console.log('getManageList------', res)
        if (res.status === 200) {
          const data = res.data;
          this.data = data.records;
          this.page.total = data.total;
        }
      });
    },
    clearData() {
      for (let key of Object.keys(this.formModel)) {
        this.formModel[key] = '';
      }
    },
    openDialog() {
      this.visible = true;
    },
    // 编辑数据
    handleEdit(row) {
      this.currentRow = row;
      for (let key of Object.keys(this.formModel)) {
        this.formModel[key] = row[key];
      }
      this.isEdit = true;
      this.visible = true;
    },
    onDialogClose() {
      this.isEdit = false;
      this.visible = false;
      this.currentRow = null;
      this.$refs['editForm'].clearValidate();
      this.clearData();
    },
    // 保存数据
    handleSubmit() {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          const data = merge({}, this.formModel);
          let api = saveManageInfo
          if (this.isEdit) {
            data.id = this.currentRow.id;
            api = editManageInfo
          }
          this.sdkCategoryOptions.forEach(item => {
            if (item.dictKey == data.categoryCode) {
              data.categoryName = item.dictValue
            }
          })

          api(data).then(res => {
            if (res.data.code == 200) {
              this.handleSuccess();
            }
          });
        }
      });
    },
    // 处理保存数据成功
    handleSuccess() {
      this.visible = false;
      this.$message({
        type: 'success',
        message: '保存成功!'
      });
      this.getList();
    },
    // 删除数据
    handleDeleteRow(row) {
      this.selectIds = row.id;
      this.handleDelete();
    },
    // 删除数据
    handleDelete() {
      if (this.selectIds === '') {
        this.$message.error('请选择要删除的数据');
        return;
      }
      this.$confirm('是否确认删除选择的记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delManage(this.selectIds).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectIds = '';
            this.getList();
            this.getChannelOptions();
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.a {
  color: red;
}
.el-tooltip__popper {
  max-width: 80% !important;
}
</style>
